<template>
  <div class="col-12 row form-group">
    <!-- {{ formFilter }} -->

    <div class="col-6" v-for="(item, i) in formFilter" :key="i">
      <b-form-group :label="item.label" :label-for="item.field">
        <b-form-input
          :id="item.field"
          v-model="item.value"
          placeholder="Enter Here"
        ></b-form-input>
      </b-form-group>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      field: Array,
      col: Array,
    },
    data() {
      return {
        filter: [],
      };
    },
    computed: {
      formFilter() {
        this.field.map((item) => {
          this.filter.push({
            value: '',
            ...item,
          });
        });
        return this.filter.slice(this.col[0], this.col[1]);
      },
    },
    methods: {
      getFilter() {
        let object = {};
        this.filter.slice(this.col[0], this.col[1]).map((item) => {
          object[item.field] = item.value;
        });
        return object;
      },
    },
  };
</script>

<style></style>
